




















































import Vue from 'vue'
import * as R from 'ramda'
import { DataPoint } from '@/jsonapi/CommonTypes'
import { USER_TIME_ZONE } from '@/utils/time'
import { buildNumberOfAwakeningOptions } from '@/components/patient-stats/graphs/detailed-reports/options/number-of-awakening-options'
import { buildTotalSleepTimeOptions } from '@/components/patient-stats/graphs/detailed-reports/options/total-sleep-time-options'
import { buildMajorInterruptionOptions } from '@/components/patient-stats/graphs/detailed-reports/options/major-interruption-options'
import { buildSleepEfficiencyOption } from '@/components/patient-stats/graphs/detailed-reports/options/sleep-efficiency-options'

export default Vue.extend({
  props: {
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    patientWithDetailedReports: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isNoData() {
      return !this.numOfAwakenings.length && !this.totalSleepTimes.length && !this.majorInterruptions.length
    },
    sleepEfficiencies(): DataPoint[] {
      return R.pathOr([], ['sleepReport', 'sleepEfficiencies'], this.patientWithDetailedReports)
    },
    numOfAwakenings(): DataPoint[] {
      return R.pathOr([], ['sleepReport', 'numOfAwakenings'], this.patientWithDetailedReports)
    },
    totalSleepTimes(): DataPoint[] {
      return R.pathOr([], ['sleepReport', 'totalSleepTimes'], this.patientWithDetailedReports)
    },
    majorInterruptions() {
      return R.pathOr([], ['sleepReport', 'majorInterruptions'], this.patientWithDetailedReports)
    },
    buildOptions() {
      const { resultStartTimestamp, resultEndTimestamp } = this.patientWithDetailedReports
      const timezone = this.patientWithDetailedReports.timezone || USER_TIME_ZONE
      return {
        resultStartTimestamp,
        resultEndTimestamp,
        timezone,
        colors: this.$vuetify.theme.themes.light,
      }
    },
    numberOfAwakeningOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return buildNumberOfAwakeningOptions({
        ...this.buildOptions,
        numOfAwakenings: this.numOfAwakenings,
      })
    },
    sleepEfficiencyOptions(): echarts.EChartOption<echarts.EChartOption.SeriesLine> {
      return buildSleepEfficiencyOption({
        ...this.buildOptions,
        sleepEfficiencies: this.sleepEfficiencies,
      })
    },
    totalSleepTimeOptions(): echarts.EChartOption<echarts.EChartOption.SeriesLine> {
      return buildTotalSleepTimeOptions({
        ...this.buildOptions,
        totalSleepTimes: this.totalSleepTimes,
      })
    },
    majorInterruptionOptions(): echarts.EChartOption<echarts.EChartOption.SeriesCustom> {
      return buildMajorInterruptionOptions({
        ...this.buildOptions,
        majorInterruptions: this.majorInterruptions,
      })
    },
  },
})
